<template>
  <div class="d-flex justify-end mt-4 mr-4">
    <!-- Componente del Menú -->
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn style="background-color:#FF790080;"  elevation="0" fab x-small dark v-on="on" icon>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" style="color: white; font-size: 22px">mdi-account</v-icon>
            </template>
            <span>{{ $t('menuUserCompany.label.users') }}</span>
          </v-tooltip>
        </v-btn>
      </template>
      <v-list>       
        <v-list-item >
          <detailsCompany                
            :companyProps="menuUserCompany"    
            :disableComission= false 
            ><span><v-icon color="primary">mdi-border-color</v-icon>{{ $t('menuUserCompany.label.editCompany') }}</span>
          </detailsCompany>
        </v-list-item>
        <v-list-item >
          <detailsUsersAdmin   
          :usersAdminProps= "idUsuario"         
            :disableUser= false    
            ><span><v-icon color="primary">mdi-border-color</v-icon>{{ $t('menuUserCompany.label.editUser') }}</span>
          </detailsUsersAdmin>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
 
<script>

import detailsCompany from '@/views/companies/pages/detail_companies/detail_company_page.vue';
import detailsUsersAdmin from '@/views/users_admin/pages/detail_users_admin/detail_users_admin_pague.vue';

import {
  MENUUSERCOMPANY_M,  
  GET_MENU_USER_COMPANY,
  ACTION_GET_MENU_USER_COMPANY,
} from "@/shared/components/menu_user_company/store/types/types.js";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "menuUserCompany",
  components: {
    detailsCompany,
    detailsUsersAdmin
  },
  data(){
    return{
      idUsuario:  sessionStorage.getItem("idUsuario")
    }
  },
  async mounted() {
    this.getActionMenuUserCompany();
  },

  computed: {
    ...mapGetters({
      menuUserCompany: [`${MENUUSERCOMPANY_M}${GET_MENU_USER_COMPANY}`],
    }),
  },
  methods: {
    ...mapActions({
      getActionMenuUserCompany: `${MENUUSERCOMPANY_M}${ACTION_GET_MENU_USER_COMPANY}`,
    }),  
  },
};
</script>
 
<style lang="css">
.v-badge--dot .v-badge__badge {
  border-radius:4.5px;
  height:6px;
  min-width: 0;
  padding: 0;
  width: 6px;
  margin: 0px 0px -7px -7px;
}
 
.brand-fixed {
  height: 6rem;
  width: 6rem;
}
 
::-webkit-scrollbar {
  width: 0.4em;
}
 
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 1em;
}
 
.d-flex {
  display: flex;
  align-items: center;
}
.d-flex > * {
  margin-right: 10px;
}
 
</style>